import React, { useEffect, useState } from 'react';
import {
	NavLink,
	useNavigate,
	useLocation,
	useSearchParams
} from 'react-router-dom';
import {
	Box, Paper, Tooltip, Typography, Grid2 as Grid
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import { TERTIARY_GREY, SUVA_GREY } from '../../Assets/Constants/theme.js';
import { useQueryParameters } from '../Common/use-query-parameters.js';
import CkeditorMobilesidebar from '../Common/CKeditor/MobileSidebar/ckeditor-mobilesidebar.js';
import { individualSidebarMenu, sideBarMenu } from '../../Assets/Constants/json_constants.js';
import { updateDashboardRoutes, updateStatus } from '../../Store/AuthSlice/auth-slice.js';
import { routerData } from '../../utils/util.js';
import permissions from '../../utils/permissions.js';
import useAccountType from '../Hooks/use-account-type.js';

export default function SideBar() {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const [searchParams, setSearchParams] = useSearchParams();
	const documentId = searchParams.get('documentId');
	const { viewEsignStats, viewDigitalStampStats } = permissions();

	const isMobile = useMediaQuery('(max-width:768px)');
	const { menu } = useSelector((state) => state.auth.userInfo);
	const [sideBarRoute, setSideBarRoute] = useState(sideBarMenu);
	const { getParameter } = useQueryParameters();
	const accountType = useAccountType();

	const onClickTab = (e, path) => {
		if (location.pathname === '/edit') {
			e.preventDefault();
			dispatch(updateStatus({ value: true, data: { saveDraft: true } }));
			return;
		}

		if (
			path !== '/new-esign'
			&& location.pathname === '/new-esign'
			&& documentId
		) {
			e.preventDefault();
			searchParams.append('approval', true);
			setSearchParams(searchParams);
		} else {
			navigate(path);
		}
	};

	useEffect(() => {
		if (accountType === 'individual') {
			setSideBarRoute(individualSidebarMenu);
		} else if (menu) {
			const menuItem = Object.keys(menu);
			const temp = routerData(sideBarMenu, menu, menuItem);
			dispatch(updateDashboardRoutes(temp));
			setSideBarRoute(temp);
		}
	}, [accountType, menu, location]);

	const createmode = getParameter('createmode');

	return (
		<>
			{isMobile && location.pathname !== '/new-esign' ? (
				<Box sx={{ width: '100%' }}>
					<Paper
						sx={{
							position: 'fixed',
							bottom: 0,
							left: 0,
							right: 0,
							borderRadius: '12px 12px  0 0'
						}}
						elevation={3}
					>
						{createmode === 'false' && <CkeditorMobilesidebar />}
						<Grid
							justifyContent='space-between'
							container
							pt={2}
							pb={2}
							paddingInlineEnd={5}
							ml='58px'
						>
							{sideBarRoute.map((val, index) => {
								let isDisabled
								= val.link === '/statistics'
								&& !viewEsignStats
								&& !viewDigitalStampStats;
								if (accountType === 'individual' && val.link === '/statistics') {
									isDisabled = true;
								}

								if (isDisabled) {
									return (
										<Box style={{ width: '100%', height: '100%' }} key={'a' + index}>
											<div
												style={{
													justifyContent: 'center',
													display: 'flex',
													height: '100%',
													alignItems: 'center'
												}}
											>
												{val?.logo ? (
													<val.image />
												) : (
													<img
														style={{ width: '35px', height: '35px' }}
														src={val.image}
														alt={'val.image' + index}
													/>
												)}
											</div>
										</Box>
									);
								}

								return (
									<Grid key={'a' + index}>
										{val.showMobile && (
											<NavLink
												style={({ isActive }) =>
													isActive
														? { stroke: TERTIARY_GREY }
														: { stroke: SUVA_GREY }
												}
												to={val.link}
											>
												<Tooltip
													enterTouchDelay={0}
													title={val.title === 'Logo' ? 'Statistics' : val.title}
													placement='top'
												>
													<Box>
														<val.image />
													</Box>
												</Tooltip>
											</NavLink>
										)}
									</Grid>
								);
							})}
						</Grid>
					</Paper>
				</Box>
			) : (
				<Box sx={{ height: '100vh', position: 'fixed' }}>
					<ul style={{ listStyle: 'none' }}>
						{sideBarRoute.map((val, index) => {
							let isDisabled
								= val.link === '/statistics'
								&& !viewEsignStats
								&& !viewDigitalStampStats;
							if (accountType === 'individual' && val.link === '/statistics') {
								isDisabled = true;
							}

							const containerStyle = {
								pointerEvents: isDisabled ? 'none' : 'auto',
								height: '60px',
								width: '100%',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center'
							};

							return (
								<li key={'a' + index}>
									<Tooltip
										disableFocusListener
										title={
											<Typography>
												{val.title === 'Logo' ? 'Statistics' : val.title}
											</Typography>
										}
										arrow
										placement='right'
									>
										<div style={containerStyle}>
											{isDisabled ? (
												<Box style={{ width: '100%', height: '100%' }}>
													<div
														style={{
															justifyContent: 'center',
															display: 'flex',
															height: '100%',
															alignItems: 'center'
														}}
													>
														{val?.logo ? (
															<val.image />
														) : (
															<img
																style={{ width: '35px', height: '35px' }}
																src={val.image}
																alt=''
															/>
														)}
													</div>
												</Box>
											) : (
												<NavLink
													onClick={(e) => onClickTab(e, val.link)}
													style={({ isActive }) =>
														isActive
															? { stroke: TERTIARY_GREY }
															: { stroke: SUVA_GREY }
													}
													to={val.link}
													disabled={isDisabled}
												>
													<Box style={{ width: '100%', height: '100%' }}>
														<div
															style={{
																justifyContent: 'center',
																display: 'flex',
																height: '100%',
																alignItems: 'center'
															}}
														>
															{val?.logo ? (
																<val.image />
															) : (
																<img
																	style={{ width: '35px', height: '35px' }}
																	src={val.image}
																	alt=''
																/>
															)}
														</div>
													</Box>
												</NavLink>
											)}
										</div>
									</Tooltip>
								</li>
							);
						})}
					</ul>
				</Box>
			)}
		</>
	);
}
